import {
  customersApi,
  type CustomerEntity,
  type CreateCustomerRequest,
  type UpdateCustomerRequest,
} from '../../api/CustomersApi';

export type CustomerRecord = {
  id: string;
  name: string;
  email: string;
  username: string;
  phoneNo: string;
  address: string;
  country: string;
  dob: string;
  type: string;
  status: string;
  createdAt: string;
};

export type FetchResult = {
  records: CustomerRecord[];
  total: number;
  skip: number;
  limit: number;
};

class CustomersStore {
  private toRecord(entity: CustomerEntity): CustomerRecord {
    return {
      id: entity.userId,
      name: entity.name,
      email: entity.email || entity.username,
      username: entity.username,
      phoneNo: entity.phoneNo || '',
      address: entity.address || '',
      country: entity.country || '',
      dob: (entity.dob as string) || '',
      type: (entity.type as string) || '',
      status: (entity.status as string) || 'active',
      createdAt: entity.createdAt,
    };
  }

  async fetch(params?: { skip?: number; limit?: number; search?: string }): Promise<FetchResult> {
    const { data: response } = await customersApi.list(params);
    const list = Array.isArray(response.data) ? response.data : [];

    return {
      records: list.map((e) => this.toRecord(e)),
      total: response.total ?? list.length,
      skip: response.skip ?? 0,
      limit: response.limit ?? 10,
    };
  }

  async create(input: CreateCustomerRequest): Promise<CustomerRecord> {
    const { data } = await customersApi.create(input);
    return this.toRecord(data);
  }

  async update(id: string, input: UpdateCustomerRequest): Promise<CustomerRecord> {
    const { data } = await customersApi.update(id, input);
    return this.toRecord(data);
  }
}

export const customersStore = new CustomersStore();
